module.exports = __webpack_public_path__ + "17a9097bbd6ad5c963fb0dad59715119.svg";